/**
 * Local filter form state for the transfer list (Angular `filterForm` parity).
 */
export interface TransferFilterFormValues {
  search: string
  org_id: string
  company_id: string
  property_id: string
  process_name: string
  status: string
  fk_team_id: string
  dateStart: Date | null
  dateEnd: Date | null
}

export const DEFAULT_TRANSFER_FILTER_FORM: TransferFilterFormValues = {
  search: '',
  org_id: '',
  company_id: '',
  property_id: '',
  process_name: '',
  status: 'Pending',
  fk_team_id: '',
  dateStart: null,
  dateEnd: null,
}
